import React, { Component } from "react";
import Select from "react-select";
import { TextareaAutosize } from "@material-ui/core";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

const styles = {
  root: {
    color: "#2CBDD7",
  },
};

const hiddenFileInput = React.createRef(null);
const hiddenFileInput_r = React.createRef(null);

class ModalCEE extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Certificado de exportación</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="form-group col-lg-6">
                      {/* <label htmlFor="producto_clv">
                      Producto: <span className="text-danger"> *</span>
                    </label> */}
                      {/* NOMBRE PRODUCTO (input) */}
                      <label htmlFor="nombre_producto">
                        Nombre comercial:{" "}
                        <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        name="nombre_comercial"
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.producto_exportacion.nombre_comercial
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      />
                    </div>

                    {/* TIPO DE PRODUCTO */}
                    <div className="form-group col-lg-6">
                      <label htmlFor="causa_sancion">
                        Tipo de producto:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="tipo_producto"
                        className="form-control m-b-5"
                        value={
                          this.props.state.producto_exportacion.tipo_producto
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_tipo_producto.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    {/* Tipo producto */}
                  </div>

                  <div
                    className={
                      !this.props.state.producto_exportacion.es_fabricante
                        ? "row"
                        : "row hide"
                    }
                  >
                    {/* NO ES FABRICANTE ENTONCES BUSCAMOS ESTABLECIMIENTO POR GUID Y NOMBRE*/}
                    <div className="form-group col-md-6">
                      <label>Razón social</label>

                      <input
                        type="text"
                        name="razon_social"
                        id="razon_social_e"
                        onChange={this.props.component.handleEstablecimiento}
                        value={this.props.state.establecimiento.razon_social}
                        className="form-control"
                        placeholder="Ingrese razón social "
                        required
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label>GUID</label>

                      <input
                        type="text"
                        name="guid"
                        id="guid_e"
                        onChange={this.props.component.handleEstablecimiento}
                        value={this.props.state.establecimiento.guid}
                        className="form-control"
                        maxLength="4"
                        placeholder="Ingrese GUID "
                        required
                      />
                    </div>

                    <div className="col-md-1">
                      <br />
                      <div
                        id="addEst"
                        onClick={this.props.component.handleGuidEstablecimiento}
                        className=" btn btn-light"
                      >
                        <i className="fa fa-th"></i>
                      </div>
                    </div>

                    <br />
                  </div>

                  <div className="row">
                    {/* FABRICANTE (input razon social y guid si mi establecimiento no es fabricante)->(si no, solo traer la info de fabricante, direccion,pais de origen, representantes legales) */}
                    <div className="form-group col-lg-6">
                      <label htmlFor="nombre_producto">
                        Fabricante: <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.producto_exportacion.establecimiento
                            .razon_social
                        }
                        /* onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      } */
                        disabled={true}
                      />
                    </div>

                    <div className="form-group col-lg-6">
                      <label htmlFor="nombre_producto">
                        Dirección: <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.producto_exportacion.establecimiento
                            .direccion
                        }
                        /*  onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      } */
                        disabled={true}
                      />
                    </div>

                    <div className="form-group col-lg-6">
                      <label htmlFor="nombre_producto">
                        País fabricante: <span className="text-danger"> *</span>{" "}
                        {/* disabled */}
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        disabled={true}
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.producto_exportacion.establecimiento
                            .pais_name
                        }
                        /* onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      } */
                      />
                    </div>

                    <div className="form-group col-lg-6">
                      <label htmlFor="nombre_producto">
                        GUID: <span className="text-danger"> *</span>{" "}
                        {/* disabled */}
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        disabled={true}
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.producto_exportacion.establecimiento
                            .guid
                        }
                        /* onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      } */
                      />
                    </div>
                  </div>

                  {/* PRINCIPIO ACTIVO (select) */}
                  {/* <div className="row"> */}
                  {/* className={" "}
                    {this.props.state.producto_exportacion.tipo_establecimiento.includes(
                      "1"
                    ) ||
                    this.props.state.producto_exportacion.tipo_establecimiento.includes(
                      "2"
                    )
                      ? "row"
                      : "row hide"}
                    */}
                  {this.props.state.producto_exportacion.tipo_producto ===
                  "1" ? (
                    <div className="row" id="principios_activos">
                      <div className="form-group col-md-5">
                        Principio activo: <span className="text-danger">*</span>
                        <div className="row" style={{ marginLeft: "0.09em" }}>
                          <select
                            name="principio_activo_id"
                            className="form-control m-b-5 "
                            value={
                              this.props.state.producto_exportacion
                                .principio_activo.principio_activo_id
                            }
                            onChange={
                              this.props.component.handlePrincipioActivo
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_principios_activos.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                  data-tipo={option.descripcion}
                                >
                                  {option.nombre}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="form-group col-md-3">
                        Concentración: <span className="text-danger">*</span>
                        <input
                          name="concentracion"
                          type="number"
                          min="0"
                          onChange={this.props.component.handlePrincipioActivo}
                          value={
                            this.props.state.producto_exportacion
                              .principio_activo.concentracion
                          }
                          className="form-control m-b-5"
                          placeholder=""
                          //required
                        />
                      </div>
                      <div className="form-group col-md-3">
                        Unidad de medida: <span className="text-danger">*</span>
                        <div className="row">
                          <select
                            onChange={
                              this.props.component.handlePrincipioActivo
                            }
                            name="unidad_medida"
                            className="form-control m-b-5 "
                            value={
                              this.props.state.producto_exportacion
                                .principio_activo.unidad_medida
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_unidad_medida.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                      <div
                        className={"col-md-1"}
                        style={{ marginTop: "1.5em" }}
                      >
                        <button
                          type="button"
                          id="addPrincipioActivo"
                          className="btn btn-info col-md-12 "
                          onClick={this.props.component.addPrincipioActivo}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {/* </div> */}

                  {/* Lista principios activos */}
                  {this.props.state.producto_exportacion.tipo_producto ===
                  "1" ? (
                    <div
                      className={
                        this.props.state.producto_exportacion.principios_activos
                          .length > 0
                          ? "row"
                          : "row hide"
                      }
                    >
                      <div id="listaPrincipiosActivos" className="col-md-12">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Principio activo</th>
                              <th>Concentración</th>
                              <th>Unidad de medida</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.producto_exportacion.principios_activos.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.principio_activo_name}</td>
                                  <td>{reg.concentracion}</td>
                                  <td>{reg.unidad_medida_name}</td>
                                  <td>
                                    <button
                                      id={index}
                                      onClick={
                                        this.props.component
                                          .removePrincipioActivo
                                      }
                                      className="btn btn-warning pull-right"
                                    >
                                      <i
                                        id={index}
                                        onClick={
                                          this.props.component
                                            .removePrincipioActivo
                                        }
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null}

                  {/* excipiente */}
                  {this.props.state.producto_exportacion.tipo_producto ===
                  "1" ? (
                    <div
                      className="row"
                      /*                     className={this.props.state.producto_exportacion.tipo_establecimiento.includes("3") || this.props.state.producto_exportacion.tipo_establecimiento.includes("4") ? "row": "row hide"}
                       */ id="excipientes"
                    >
                      <div className="form-group col-md-5">
                        Excipiente: <span className="text-danger">*</span>
                        <select
                          name="excipiente_id"
                          value={
                            this.props.state.producto_exportacion.excipiente
                              .excipiente_id
                          }
                          onChange={this.props.component.handleExcipiente}
                          value={
                            this.props.state.producto_exportacion.excipiente
                              .excipiente_id
                          }
                          className="form-control m-b-5"
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_excipientes.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                                data-tipo={option.descripcion}
                              >
                                {option.nombre}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        Concentración: <span className="text-danger">*</span>
                        <input
                          name="concentracion"
                          type="number"
                          onChange={this.props.component.handleExcipiente}
                          value={
                            this.props.state.producto_exportacion.excipiente
                              .concentracion
                          }
                          className="form-control m-b-5"
                          min="0"
                          placeholder=""
                          //required
                        />
                      </div>

                      <div className="form-group col-md-3">
                        Unidad de medida: <span className="text-danger">*</span>
                        <div className="row">
                          <select
                            onChange={this.props.component.handleExcipiente}
                            name="unidad_medida"
                            className="form-control m-b-5 "
                            value={
                              this.props.state.producto_exportacion.excipiente
                                .unidad_medida
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_unidad_medida.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          onClick={this.props.component.addExcipiente}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {/* Lista excipientes */}
                  {this.props.state.producto_exportacion.tipo_producto ===
                  "1" ? (
                    <div
                      className={
                        this.props.state.producto_exportacion.excipientes
                          .length > 0
                          ? "row"
                          : "row hide"
                      }
                    >
                      <div id="listaExcipientes" className="col-md-12">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Excipiente</th>
                              <th>Concentración</th>
                              <th>Unidad de medida</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.producto_exportacion.excipientes.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.excipiente_name}</td>
                                  <td>{reg.concentracion}</td>
                                  <td>{reg.unidad_medida_name_ex}</td>
                                  <td>
                                    <button
                                      id={index}
                                      onClick={
                                        this.props.component.removeExcipiente
                                      }
                                      className="btn btn-warning pull-right"
                                    >
                                      <i
                                        id={index}
                                        onClick={
                                          this.props.component.removeExcipiente
                                        }
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null}

                  {/* ANALISIS GARANTIZADO */}

                  {this.props.state.producto_exportacion.tipo_producto ===
                  "5" ? (
                    <div className="row" id="analisis">
                      <div className="form-group col-md-5">
                        Análisis garantizado:{" "}
                        <span className="text-danger">*</span>
                        <div className="row" style={{ marginLeft: "0.09em" }}>
                          <select
                            name="analisis_id"
                            value={
                              this.props.state.producto_exportacion
                                .analisis_garantizado.analisis_id
                            }
                            onChange={this.props.component.handleAnalisis}
                            className="form-control m-b-5"
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_analisis.map((option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="form-group col-md-6">
                        Porcentaje(%): <span className="text-danger">*</span>
                        <input
                          type="number"
                          name="porcentaje"
                          value={
                            this.props.state.producto_exportacion
                              .analisis_garantizado.porcentaje
                          }
                          onChange={this.props.component.handleAnalisis}
                          className="form-control m-b-5"
                          placeholder=""
                          min="1"
                          //required
                        />
                      </div>

                      <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          onClick={this.props.component.addAnalisis}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {/* Lista ANALISIS GARANTIZADO */}

                  {this.props.state.producto_exportacion.tipo_producto ===
                  "5" ? (
                    <div
                      className={
                        this.props.state.producto_exportacion.analisis.length >
                        0
                          ? "row"
                          : "row hide"
                      }
                    >
                      <div id="listaAnalisis" className="col-md-12">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Análisis garantizado</th>
                              <th>Porcentaje(%)</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.producto_exportacion.analisis.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.analisis_name}</td>
                                  <td>{reg.porcentaje}</td>
                                  <td>
                                    <button
                                      id={index}
                                      onClick={
                                        this.props.component.removeAnalisis
                                      }
                                      className="btn btn-warning pull-right"
                                    >
                                      <i
                                        id={index}
                                        onClick={
                                          this.props.component.removeAnalisis
                                        }
                                        className="fas fa-trash"
                                      ></i>
                                    </button>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null}

                  {/* DOSIS Y ESPECIE (select dinamico) */}

                  <div className="row" id="dosis_especies_via">
                    <div className="form-group col-md-5">
                      Dosis por especie y vía de administración:
                      <input
                        type="input"
                        name="dosis"
                        onChange={this.props.component.handleDosisEspecie}
                        value={
                          this.props.state.producto_exportacion.dosis_especie
                            .dosis
                        }
                        className="form-control m-b-5"
                        //style={{width:"36.3em",resize: "horizontal"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.props.state.producto_exportacion.dosis_especie
                          .tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-6"
                      }
                    >
                      Especie destino:
                      <div className="row" style={{ marginLeft: "0.08em" }}>
                        <select
                          onChange={this.props.component.handleDosisEspecie}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={
                            this.props.state.producto_exportacion.dosis_especie
                              .especie_id
                          }
                          /* style={{ width: "20.5em" }} */
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_especies.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className={
                        this.props.state.producto_exportacion.dosis_especie
                          .tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-3 hide"
                      }
                    >
                      Categoría:
                      <div className="row">
                        <select
                          onChange={this.props.component.handleDosisEspecie}
                          name="categoria_id"
                          id="categoria_id"
                          className="form-control m-b-5"
                          value={
                            this.props.state.producto_exportacion.dosis_especie
                              .categoria_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_categoria
                            .filter(
                              (e) =>
                                e.especie_id ===
                                this.props.state.producto_exportacion
                                  .dosis_especie.especie_id
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                data-categoria={option.descripcion}
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.props.component.addDosisEspecie}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista dosis */}

                  <div
                    className={
                      this.props.state.producto_exportacion.dosis.length > 0
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDosis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Dosis</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.producto_exportacion.dosis.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.dosis}</td>
                                <td>{reg.especie_name}</td>
                                <td>{reg.categoria_name}</td>
                                <td>
                                  <button
                                    type="button"
                                    id={index}
                                    onClick={
                                      this.props.component.removeDosisEspecie
                                    }
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={
                                        this.props.component.removeDosisEspecie
                                      }
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* TIPO DE ENVASE */}

                  <div className="row" id="envases">
                    <div className="form-group col-md-5">
                      Tipo de envase/empaque:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.props.component.handleEmpaque}
                          name="empaque_id"
                          className="form-control m-b-5 "
                          value={
                            this.props.state.producto_exportacion.empaque
                              .empaque_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_empaque.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Presentaciones cantidad:{" "}
                      <span className="text-danger">*</span>
                      <input
                        name="presentacion_cantidad"
                        type="input"
                        onChange={this.props.component.handleEmpaque}
                        value={
                          this.props.state.producto_exportacion.empaque
                            .presentacion_cantidad
                        }
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.props.component.handleEmpaque}
                          name="presentacion_unidad_medida"
                          className="form-control m-b-5 "
                          value={
                            this.props.state.producto_exportacion.empaque
                              .presentacion_unidad_medida
                          }
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_unidad_medida.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.props.component.addEmpaque}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista empaques */}

                  <div
                    className={
                      this.props.state.producto_exportacion.empaques.length > 0
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaEmpaques" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Empaque</th>
                            {/*  <th>Presentaciones</th> */}
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.producto_exportacion.empaques.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.empaque_name}</td>
                                {/* <td>{reg.presentacion}</td> */}
                                <td>{reg.presentacion_cantidad}</td>
                                <td>{reg.presentacion_unidad_medida_name}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={this.props.component.removeEmpaque}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={
                                        this.props.component.removeEmpaque
                                      }
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* PERIODO DE RETIRO Y ESPECIE PRODUCTO (select dinamico) */}
                  {this.props.state.producto_exportacion.tipo_producto ===
                  "1" ? (
                    <div className="row" id="periodo_descarte">
                      <div className="form-group col-md-3">
                        Periodo de retiro o descarte:{" "}
                        <span className="text-danger"></span>
                        <input
                          type="number"
                          name="periodo"
                          value={
                            this.props.state.producto_exportacion.descarte
                              .periodo
                          }
                          onChange={this.props.component.handleDescarte}
                          className="form-control m-b-5"
                          //style={{width:"36.3em"}}
                          placeholder=""
                          min="1"
                          //required
                        />
                      </div>

                      <div className="form-group col-md-2">
                        Tiempo: <span className="text-danger"></span>
                        <select
                          name="medida_tiempo_id"
                          className="form-control m-b-5 "
                          value={
                            this.props.state.producto_exportacion.descarte
                              .medida_tiempo_id
                          }
                          onChange={this.props.component.handleDescarte}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_medida_tiempo
                            .filter(
                              (e) =>
                                e.descripcion === "Días" ||
                                e.descripcion === "Horas"
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-6">
                        Especie producto: <span className="text-danger"></span>
                        <select
                          onChange={this.props.component.handleDescarte}
                          name="especie_prod_id"
                          className="form-control  "
                          value={
                            this.props.state.producto_exportacion.descarte
                              .especie_prod_id
                          }
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_especies_producto.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          onClick={this.props.component.addDescarte}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {/* Lista descarte */}

                  <div
                    className={
                      this.props.state.producto_exportacion.descartes.length > 0
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDescartes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Periodo</th>
                            <th>Tiempo</th>
                            <th>Especie producto</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.producto_exportacion.descartes.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.periodo}</td>
                                <td>{reg.medida_tiempo_name}</td>
                                <td>{reg.especie_prod_name}</td>
                                <td>
                                  <button
                                    id={index}
                                    onClick={
                                      this.props.component.removeDescarte
                                    }
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={
                                        this.props.component.removeDescarte
                                      }
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* USO (input) */}
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="causa_sancion">
                        {this.props.state.producto_exportacion.tipo_producto ===
                        "1"
                          ? "Indicaciones de uso: "
                          : "Uso: "}
                        <span className="text-danger"> *</span>
                      </label>

                      <TextareaAutosize
                        rowsMin={3}
                        rowsMax={3}
                        name="uso"
                        value={this.props.state.producto_exportacion.uso}
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                    {/* precauciones (input) 

                   <div className="form-group col-lg-6">
                    <label htmlFor="precauciones">
                      Precauciones de uso: <span className="text-danger"> *</span>
                    </label>

                     <input
                        type="input"
                        className="form-control"
                        
                        name="precauciones_generales"
                        //placeholder="Causa de la sanción"
                        value={this.props.state.producto_exportacion.precauciones_generales}
                        onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      }
                      /> 

                      <TextareaAutosize 
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_uso"
                        value={this.props.state.producto_exportacion.precauciones_uso}
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />

                   </div>*/}
                  </div>

                  {/* CADUCIDAD (input y select unidad medida) */}

                  <div className="row">
                    <div className="form-group col-md-6">
                      Caducidad del producto:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="number"
                          name="caducidad_producto"
                          value={
                            this.props.state.producto_exportacion
                              .caducidad_producto
                          }
                          onChange={(e) =>
                            this.props.component.handleChangeCEE(e)
                          }
                          className="form-control m-b-5 "
                          placeholder=""
                          min="1"
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Tiempo: <span className="text-danger">*</span>
                      <select
                        name="medida_tiempo_id"
                        className="form-control m-b-5 "
                        value={
                          this.props.state.producto_exportacion.medida_tiempo_id
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_medida_tiempo.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {/* forma farmaceutica */}
                    <div className="form-group col-md-12">
                      {this.props.state.producto_exportacion.tipo_producto ===
                      "1"
                        ? "Forma farmacéutica: "
                        : "Forma de comercialización: "}
                      <span className="text-danger">*</span>
                      <select
                        name="forma_farmaceutica_id"
                        className="form-control m-b-5 "
                        value={
                          this.props.state.producto_exportacion
                            .forma_farmaceutica_id
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_forma_farmaceutica.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {/* clasificación */}
                    <div className="form-group col-md-6">
                      Clasificación: <span className="text-danger">*</span>
                      <select
                        name="clase_producto_id"
                        className="form-control m-b-5 "
                        value={
                          this.props.state.producto_exportacion
                            .clase_producto_id
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_clasificacion.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    {/* fin clasificación */}
                    {/* condiciones de venta */}
                    <div className="form-group col-md-6">
                      Condiciones de venta:{" "}
                      <span className="text-danger">*</span>
                      <select
                        name="condicion_venta_id"
                        className="form-control m-b-5 "
                        value={
                          this.props.state.producto_exportacion
                            .condicion_venta_id
                        }
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_condiciones_venta.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    {/* fin condiciones de venta */}
                  </div>

                  <div className="row">
                    {/* FIN DE EXPORTACION */}
                    {/*  <div className="form-group col-lg-6">
                    <label htmlFor="causa_sancion">
                      Fin de exportación: <span className="text-danger"> *</span>
                    </label>
                    <select
                        name="fin_exportacion"
                        className="form-control m-b-5"
                        value={this.props.state.fin_exportacion}
                        onChange={(e) =>
                          this.props.component.handleFinExportacion(e) //cambiar
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_fin_exportacion.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                      </div> */}

                    {/* PAIS  */}
                    <div className="form-group col-lg-12">
                      <label htmlFor="pais_clv">
                        País destino: <span className="text-danger"> *</span>
                      </label>
                      <Select
                        isMulti
                        styles={colourStyles}
                        placeholder="Seleccione"
                        onChange={this.props.component.handlePaises}
                        theme="neutral40"
                        value={this.props.state.paises}
                        options={this.props.state.options_countries}
                        getOptionLabel={(option) => option.descripcion}
                        getOptionValue={(option) => option.id}
                        noOptionsMessage={() => "No se encontraron paises"}
                      />
                    </div>

                    {/* NUMERO DE FACTURA (input)  */}
                    {/*  <div className="form-group col-lg-6">
                    <label htmlFor="causa_sancion">
                      Número de factura: <span className="text-danger"> *</span>
                    </label>

                    <input
                        type="input"
                        className="form-control"
                        //placeholder="Causa de la sanción"
                        value={this.props.state.numero_factura}
                        onChange={(e) =>
                        this.props.component.handleNumFactura(e)
                      }
                      />
                   </div> */}

                    <div className="form-group col-lg-12">
                      <label htmlFor="clv">
                        Petición: <span className="text-danger"> *</span>
                      </label>

                      <TextareaAutosize
                        rowsMin={3}
                        rowsMax={3}
                        name="peticion"
                        value={this.props.state.producto_exportacion.peticion}
                        onChange={(e) =>
                          this.props.component.handleChangeCEE(e)
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>

                    {/*  LISTA REPRESENTANTE LEGAL */}
                    <div
                      className={
                        this.props.state.producto_exportacion.establecimiento
                          .representantes_legales.length > 0
                          ? "form-group col-md-12"
                          : "form-group col-md-12 hide"
                      } /*  className="form-group col-md-12" */
                    >
                      <label>Representantes legales: </label>
                      <span className="text-danger"> *</span>
                      <div id="listaRepresentantes">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.producto_exportacion.establecimiento.representantes_legales.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>
                                    {reg.nombres +
                                      " " +
                                      reg.apellido_paterno +
                                      " " +
                                      reg.apellido_materno}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <fieldset>
            <legend>Justificación</legend>
            <div className="container">
              <div className="row">
                <div className="form-group col-lg-12">
                  <label htmlFor="cle">
                    Justificación: <span className="text-danger"> *</span>
                  </label>

                  <TextareaAutosize
                    rowsMin={3}
                    rowsMax={3}
                    name="Justsificacion"
                    title="Justificación"
                    value={this.props.state.justificacion}
                    onChange={(e) =>
                      this.props.component.handleJustificacion(e)
                    }
                    className="form-control m-b-5"
                    maxLength={500}
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalCEE(1);
                //this.props.component.limpiarCampos(1, 0);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit(2);
              }}
              className="btn btn-success"
            >
              Generar certificado
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalCEE;
